import {FIELD_TYPE} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, SELECT, DATE, COLOR} = FIELD_TYPE;
const dataFields: DataFormField[] = [
  {
    type: INPUT,
    label: "ID",
    name: "id",
    disable: true,
  },
  {
    type: INPUT,
    label: "Tên nhóm thuốc",
    name: "name",
    rules: [{required: true, message: "Chưa nhập tên nhóm thuốc"}],
  },
  {
    type: INPUT,
    label: "Mô tả",
    name: "description",
    rules: [{required: true, message: "Chưa nhập mô tả"}],
  },
  {
    type: INPUT,
    label: "Người tạo",
    name: "createBy",
    value: localStorage.getItem("fullName"),
    disable: true,
  },
];
export {dataFields};
